import { Component } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { SponsorService } from '../services/sponsor.service';

import { Sponsor } from '../models/sponsor.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-sponsor-list',
  templateUrl: './sponsor-list.component.html'
})
export class SponsorListComponent {

  constructor(public service: SponsorService, private modalService: NgbModal, private notificationService: NotificationService) { }

  ngOnInit() {
    this.onSearch();
  }

  closeResult = '';
  model = new Sponsor();
  modelSearch = new Sponsor();

  open(content, model) {
    if (model == null)
      model = new Sponsor();

    this.model = Object.assign({}, model);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }

  onArchive(id) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.service.archive(id).subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.onSearch();
      },
      err => { console.log(err); }
    );

  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = this.modelSearch;
    this.service.search();
  }
}

